module.exports = __webpack_public_path__ + "img/page11.4102aa24.jpg";